import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  startAfter,
} from 'firebase/firestore';
import { db } from './config';
import { demoFirestoreService, isDemoModeEnabled } from '../demo/demoRuntime';

export const collectionRefs = {
  users: 'users',
  exercises: 'exercises',
  workouts: 'workouts',
  schedules: 'schedules',
  challenges: 'challenges',
  userStats: 'userStats',
  trainingGroups: 'trainingGroups',
  performanceLogs: 'performanceLogs',
  playerNotes: 'playerNotes',
};

const realFirestoreService = {
  create: async (collectionName, data) => {
    try {
      const docRef = await addDoc(collection(db, collectionName), {
        ...data,
        createdAt: new Date(),
      });
      return { id: docRef.id, ...data };
    } catch (error) {
      console.error(`Error creating ${collectionName}:`, error);
      throw error;
    }
  },

  read: async (collectionName, docId) => {
    try {
      const docRef = doc(db, collectionName, docId);
      const docSnap = await getDoc(docRef);
      return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
    } catch (error) {
      console.error(`Error reading ${collectionName}:`, error);
      throw error;
    }
  },

  readAll: async (collectionName, conditions = []) => {
    try {
      let q = collection(db, collectionName);
      if (conditions.length > 0) {
        q = query(q, ...conditions);
      }
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map((docSnapshot) => ({ id: docSnapshot.id, ...docSnapshot.data() }));
    } catch (error) {
      console.error(`Error reading all from ${collectionName}:`, error);
      throw error;
    }
  },

  update: async (collectionName, docId, data) => {
    try {
      const docRef = doc(db, collectionName, docId);
      await updateDoc(docRef, {
        ...data,
        updatedAt: new Date(),
      });
      return { id: docId, ...data };
    } catch (error) {
      console.error(`Error updating ${collectionName}:`, error);
      throw error;
    }
  },

  delete: async (collectionName, docId) => {
    try {
      await deleteDoc(doc(db, collectionName, docId));
      return { id: docId, deleted: true };
    } catch (error) {
      console.error(`Error deleting from ${collectionName}:`, error);
      throw error;
    }
  },

  query: (collectionName, ...conditions) => query(collection(db, collectionName), ...conditions),
  where,
  orderBy,
  limit,
  startAfter,
};

export const firestoreService = isDemoModeEnabled() ? demoFirestoreService : realFirestoreService;

export { where, orderBy, limit, startAfter };
